import type { Lang } from '~/types';
import { Store } from '@tanstack/react-store';
import { getLanguage, setLanguage } from '~/services/languageService';

const l = getLanguage();

export const langStore = new Store<Lang>(l);
langStore.subscribe((state) => {
  setLanguage(state);
});

export function formatDayOfWeek(dateString: string): string {
  const locale = langStore.state.toUpperCase();
  const localeStr = locale === 'RS' ? 'sr-Latn' : `${locale}-Latn`;
  // try to parse the date string, if fails, split by "-" and new Date(y,m,d)
  const [year, month, day] = dateString.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day))
    .toLocaleDateString(localeStr, { weekday: 'long' })
    .toUpperCase();
}

export function formatDate(dateString: string): string {
  const locale = langStore.state.toUpperCase();
  const localeStr = locale === 'RS' ? 'sr-Latn' : `${locale}-Latn`;
  const [year, month, day] = dateString.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day))
    .toLocaleDateString(localeStr, {
      month: 'long',
      day: 'numeric',
    });
}

export function formatTime(dateString: string): string {
  const locale = langStore.state.toUpperCase();
  // Use 'hu-HU' for 24h, otherwise default to locale
  const localeStr = locale === 'HU' ? 'hu-HU' : (locale === 'RS' ? 'sr-Latn' : `${locale}-Latn`);
  const date = new Date(dateString);
  return date.toLocaleTimeString(localeStr, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
